<div class="hamburger" [ngClass]="{ open: open }">
    <span></span>
    <span></span>
    <span></span>
</div>
